/*#########################################################
    ファイルの入稿
#########################################################*/
// 書き込み先
const target_cover = document.querySelector('#target_cover') || null;
const target_body = document.querySelector('#target_body') || null;

// ドロップゾーンの読み込み中表示
const loading_cover = document.querySelector('[data-name="loading_cover"]') || null;
const loading_body = document.querySelector('[data-name="loading_body"]') || null;

// テンプレート
const $template_progress = document.querySelector('#template_progress') || null;
const template_body_index = document.getElementById('template_body_index') ? getCloneNode(document.getElementById('template_body_index')) : null;
const template_cover_thumbnail = document.getElementById('template_cover_thumbnail') ? getCloneNode(document.getElementById('template_cover_thumbnail')) : null;
const template_body_thumbnail = document.getElementById('template_body_thumbnail') ? getCloneNode(document.getElementById('template_body_thumbnail')) : null;
const template_progress_bar = document.querySelector('#template_progress_bar') || null;

const spinner_icon = `<div class="spinner-border spinner-border-sm text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
    </div>`;

const success_icon = `<i class="fas fa-check-circle text-success"></i>`;
const error_icon = `<i class="fas fa-exclamation-circle text-danger"></i>`;

// bodyにドラッグされた時の処理
const body = document.querySelector('body');
body.addEventListener('dragover', function (e) {
    e.stopPropagation();
    e.preventDefault();
    this.querySelectorAll('.drop_zone__inner').forEach(function (e) {
        e.classList.remove("d-none");
    });
}, false);
body.addEventListener('dragleave', function (e) {
    e.stopPropagation();
    e.preventDefault();
    this.querySelectorAll('.drop_zone__inner').forEach(function (e) {
        e.classList.add("d-none");
    });
}, false);
// 各ドロップゾーンにドラッグされた時の処理
const dropboxes = document.querySelectorAll('.drop_zone');
dropboxes.forEach(function (dropbox) {
    dropbox.addEventListener('dragover', function (e) {
        this.querySelector('.drop_zone__inner').classList.add("bg-warning", "border", "border-danger", "border-5");
    }, false);
    dropbox.addEventListener('dragleave', function (e) {
        this.querySelector('.drop_zone__inner').classList.remove("bg-warning", "border", "border-danger", "border-5");
    }, false);
    dropbox.addEventListener('drop', function (e) {
        e.stopPropagation();
        e.preventDefault();
        body.querySelectorAll('.drop_zone__inner').forEach(function (e) {
            e.classList.add("d-none");
            e.classList.remove("border", "border-warning", "border-5");
        });
        const form = this.querySelector('form');
        const input_file = form.querySelector('input[type="file"]');
        input_file.files = e.dataTransfer.files;
        upload.check(form);
        upload.reset(input_file);
    }, false);
});

module.exports = {

    /*#########################################################
        ファイル一覧取得
    #########################################################*/
    index(order_id = null) {
        let formdata = new FormData();
        formdata.append('order_id', order_id);
        if (target_cover && target_body) {
            target_cover.innerHTML = spinner_border;
            target_body.innerHTML = spinner_border;
        }
        const data = api({
            api: '/api/user/upload',
            _method: "GET",
            formdata: formdata,
            callback: this.index_showing,
            e_callback: null,
        });
    },
    // 一覧データの表示
    index_showing(data) {
        target_cover.querySelector('.spinner').remove();
        target_body.querySelector('.spinner').remove();
        // ## 取得したデータをテンプレートに設定
        const d = data.data.uploads;
        for (let i in d) {
            template_body_index.setAttribute("id", "id_" + d[i].id);
            let status_icon = success_icon;
            if (!d[i].is_completed) {
                status_icon = spinner_icon;
                template_body_index.querySelector('[data-content="progress"]').innerHTML = '';
                template_body_index.querySelector('[data-content="progress"]').classList.add('show');
                template_body_index.querySelector('[data-content="progress"]').appendChild(getCloneNode(template_progress_bar));
                template_body_index.querySelector('[data-content="proc_text"]').classList.add('show');
                template_body_index.querySelector('[data-content="proc_text"]').innerHTML = 'アップロード中...';
                if (d[i].thumbnail_meta) {
                    let proc_status = upload.get_status(d[i].thumbnail_meta.status);
                    template_body_index.querySelector('[data-content="proc_text"]').innerHTML = proc_status.text;
                    template_body_index.querySelector('.progress-bar').style.width = proc_status.percent + "%";
                }
            }
            if (d[i].thumbnail_meta && d[i].thumbnail_meta.error) {
                status_icon = error_icon;
                const message = "アップロードは完了しましたが、ファイル処理に失敗しました。";
                template_body_index.querySelector('[data-content="proc_text"]').classList.add('show');
                template_body_index.querySelector('[data-content="proc_text"]').innerHTML = `<div class="text-danger">${message}</div>`;
            }
            template_body_index.querySelector('[data-content="status"]').innerHTML = status_icon;
            template_body_index.querySelector('[data-content="original_name"]').innerHTML = d[i].original_name;
            template_body_index.querySelector('[data-content="size_formated"]').innerHTML = d[i].size_formated;
            template_body_index.querySelector('[data-content="delete"]').setAttribute('onclick', 'upload.delete(\'' + d[i].id + '\')');
            if (d[i].part == "cover") {
                target_cover.appendChild(template_body_index.cloneNode(true));
            } else {
                target_body.appendChild(template_body_index.cloneNode(true));
            }
            if (!d[i].is_completed) {
                upload.check_prpc(d[i]);
            }
        }
    },

    /*#########################################################
        ファイルのアップロード
    #########################################################*/
    // input type="file" を初期化
    reset(input_file = null) {
        if (input_file) {
            input_file.value = "";
        }
    },
    // ファイルの入稿ボタンクリック
    click(t) {
        // form_id = form_id.replace(/#/i, ''); // #を取り除く
        const form = t.closest('form');
        const input_file = form.querySelector('input[type="file"]');
        input_file.click();
        input_file.addEventListener('change', (evt) => {
            if (input_file.files.length > 0) { // ファイルが選択されている場合のみ
                upload.check(form);
            }
            upload.reset(input_file);
        }, { once: true });
    },
    // 計算
    check(form) {
        // エラーを初期化
        let error = [];
        // fomデータ本体（アップロードファイル込み）
        const formdata = new FormData(form);
        // アップロードファイルをアップロード名だけにした軽量版
        let sendData = new FormData();
        // アップロードファイルの数（APIを起動させるかどうかの判定に使用）
        let file_count = 0;
        for ([key, value] of formdata.entries()) {
            if (value instanceof File) {
                if (value.type) {
                    sendData.append('uploads[]', JSON.stringify({
                        name: value.name,
                        size: value.size
                    }));
                    file_count++;
                } else {
                    // ファイル情報が取得できない場合はエラーにして送信させない
                    error.push(value.name);

                }
            } else {
                sendData.append(key, value);
            }
        }
        if (error.length) {
            let body = 'アップロードされた下記のファイルはファイル情報が取得できませんでした。拡張子などを確認して、もう一度お試しください。<ul>';
            for (let i in error) {
                body += '<li class="strong">' + error[i] + '</li>';
            }
            body += '</ul>';
            make_modal({
                'title': 'エラー',
                'body': body,
            });
        }
        console.log(sendData.get('part'),loading_cover);
        if(sendData.get('part') == 'cover') loading_cover.style.display = "block";
        if(sendData.get('part') == 'body')  loading_body.style.display = "block";
        if (file_count) { // アップロードファイルがある場合のみ
            const data = api({
                api: '/api/user/upload',
                _method: "POST",
                formdata: sendData,
                callback: this.upload_xhr,
                e_callback: null,
                carry_data: formdata
            });
        }
    },
    // XMLHttpRequestでのアップロード
    upload_xhr(sendData, formdata) {
        if(formdata.get('part') == 'cover') loading_cover.style.display = "none";
        if(formdata.get('part') == 'body')  loading_body.style.display = "none";
        if (sendData.error) {
            make_modal({
                'title': 'エラー',
                'body': sendData.messageText,
            });
            return false;
        }
        const data = sendData.data;
        for ([key, value] of formdata.entries()) {
            if (value instanceof File) {
                // S3のアップロードURLをファイル名から検索して取得（同じファイル名は同時に送信されないはず）
                let upload_data = data.find(e => e.original_name == value.name);
                if (!upload_data || !upload_data.url) {
                    // 途中でformdataが変更されている可能性があるので、エラーを表示しない
                    // make_toast([{
                    //     'title': 'エラー',
                    //     'body': 'アップロードURLが取得できませんでした。',
                    //     'type': 'danger',
                    // }]);
                    continue;
                }
                let blob = new Blob([value], { type: upload_data.mime_type });
                const xhr = new XMLHttpRequest();
                xhr.open('PUT', upload_data.url);
                xhr.upload.addEventListener('error', (evt) => {
                    return make_modal({
                        title: 'エラー',
                        body: 'エラーが発生しました。<br />',
                    });
                });
                xhr.upload.addEventListener('loadstart', (evt) => {
                    template_body_index.querySelector('[data-content="status"]').innerHTML = spinner_icon;
                    template_body_index.setAttribute("id", "id_" + upload_data.id);
                    template_body_index.querySelector('[data-content="original_name"]').innerHTML = upload_data.original_name;
                    template_body_index.querySelector('[data-content="size_formated"]').innerHTML = upload_data.size_formated;
                    template_body_index.querySelector('[data-content="progress"]').innerHTML = '';
                    template_body_index.querySelector('[data-content="progress"]').classList.add('show');
                    template_body_index.querySelector('[data-content="progress"]').appendChild(getCloneNode(template_progress_bar));
                    template_body_index.querySelector('[data-content="proc_text"]').classList.add('show');
                    template_body_index.querySelector('[data-content="proc_text"]').innerHTML = 'アップロード中...';
                    template_body_index.querySelector('[data-content="delete"]').disabled = true;
                    if (upload_data.part == "cover") {
                        target_cover.appendChild(template_body_index.cloneNode(true));
                    } else {
                        target_body.appendChild(template_body_index.cloneNode(true));
                    }
                })
                xhr.upload.addEventListener('progress', (evt) => {
                    const percent = ((evt.loaded / evt.total) * 50).toFixed(1);
                    document.querySelector('#id_' + upload_data.id + ' .progress-bar').style.width = percent + "%";
                });
                xhr.upload.addEventListener('loadend', (evt) => {
                    const sendData = new FormData();
                    sendData.append('is_uploaded', 1);
                    sendData.append('order_id', upload_data.order_id);
                    document.querySelector('#id_' + upload_data.id + ' [data-content="proc_text"]').innerHTML = 'アップロード完了、処理を開始します...';
                    api({
                        api: '/api/user/upload/' + upload_data.id,
                        _method: "PUT",
                        formdata: sendData,
                    });
                    upload.check_prpc(upload_data);
                });
                xhr.send(blob);
            }
        }
    },
    // metadataを取得して現在の状況を取得
    check_prpc(upload_data) {
        const extname = path.extname(upload_data.full_path);
        const this_target = document.querySelector('#id_' + upload_data.id);
        let meta_url = upload_data.full_path;
        meta_url = meta_url.replace('uploads/', 'thumbnails/');
        meta_url = meta_url.replace(extname, '/metadata.json');
        fetch(
            meta_url,
            {
                method: "GET",
                headers: {
                    'X-CSRF-TOKEN': token,
                },
            })
            .then(response => {
                // 404エラーの場合はリロード
                if (response.status == 404) {
                    throw new Error("reload");
                } else if (!response.ok) {
                    throw new Error(response.statusText);
                }
                return response.json();
            })
            .then(data => {
                upload_data.data = data;
                let proc_status = upload.get_status(data.status);
                if (data.error) { // このエラーの場合は書き込み途中のエラーなので停止が必要
                    throw new Error(response.statusText);
                } else if (data.status !== "success") {
                    this_target.querySelector('[data-content="proc_text"]').innerHTML = proc_status.text;
                    this_target.querySelector('.progress-bar').style.width = proc_status.percent + "%";
                    throw new Error("reload");
                }
                this_target.querySelector('[data-content="status"]').innerHTML = success_icon;
                this_target.querySelector('[data-content="size_formated"]').innerHTML = upload_data.size_formated;
                this_target.querySelector('[data-content="delete"]').disabled = false;
                this_target.querySelector('[data-content="delete"]').setAttribute('onclick', 'upload.delete(\'' + upload_data.id + '\')');
                this_target.querySelector('[data-content="proc_text"]').innerHTML = proc_status.text;
                this_target.querySelector('.progress-bar').style.width = "100%";
                new bootstrap.Collapse(this_target.querySelector('[data-content="proc_text"]'), {
                    hide: true
                });
                new bootstrap.Collapse(this_target.querySelector('[data-content="progress"]'), {
                    hide: true
                });
                const sendData = new FormData();
                sendData.append('is_completed', 1);
                if (data.files) {
                    sendData.append('has_thumbnails', 1);
                }
                sendData.append('order_id', upload_data.order_id);
                sendData.append('thumbnail_meta', JSON.stringify(data));
                api({
                    api: '/api/user/upload/' + upload_data.id,
                    _method: "PUT",
                    formdata: sendData,
                });
            })
            .catch(error => {
                const max_retry = 3 * 60; // 3分
                // const max_retry = 5; // 3分
                // 処理回数
                upload_data.progress_count = upload_data.progress_count ? upload_data.progress_count + 1 : 1;
                if (upload_data.progress_count < max_retry && error.message == "reload") {
                    window.setTimeout(function () {
                        upload.check_prpc(upload_data);
                    }, 1000);
                    return;
                }
                // エラー処理
                let message = `${upload_data.original_name}のアップロードは成功しましたが、ファイル処理に失敗しました。<br />`;
                if (upload_data.progress_count >= max_retry) {
                    message += "処理に時間がかかりすぎたため中断しました。";
                }
                this_target.querySelector('[data-content="proc_text"]').innerHTML = `<div class="text-danger">${message}</div>`;
                this_target.querySelector('[data-content="delete"]').disabled = false;
                this_target.querySelector('[data-content="delete"]').setAttribute('onclick', 'upload.delete(\'' + upload_data.id + '\')');
                this_target.querySelector('.progress-bar').classList.add('bg-danger');
                const sendData = new FormData();
                sendData.append('order_id', upload_data.order_id);
                sendData.append('thumbnail_meta', JSON.stringify(upload_data.data));
                api({
                    api: '/api/user/upload/' + upload_data.id,
                    _method: "PUT",
                    formdata: sendData,
                });
                this_target.querySelector('[data-content="status"]').innerHTML = error_icon;
                return make_modal({
                    title: 'エラー',
                    body: message,
                });
            });
    },
    // ステータステキストから、状況を返却
    get_status(status) {
        let proc_status = {
            text: "処理を開始します...",
            percent: 55
        };
        switch (status) {
            case "file_found":
                proc_status = {
                    text: "データ解析の準備をしています...",
                    percent: 60
                };
                break;
            case "processing":
                proc_status = {
                    text: "データを解析しています...",
                    percent: 70
                };
                break;
            case "downloaded":
                proc_status = {
                    text: "データを変換しています...",
                    percent: 80
                };
                break;
            case "converted":
                proc_status = {
                    text: "データ変換が完了しました...",
                    percent: 90
                };
                break;
            case "uploading":
                proc_status = {
                    text: "変換データの保存中...",
                    percent: 95
                };
                break;
            case "success":
                proc_status = {
                    text: "処理が完了しました",
                    percent: 100
                };
                break;
            default:
        }
        return proc_status;
    },

    /*#########################################################
        ファイルの削除
    #########################################################*/

    // 削除ボタンクリック
    delete(id) {
        const data = api({
            api: '/api/user/upload/' + id,
            _method: "DELETE",
            callback: this.destroy_callback,
            e_callback: null,
        });
        if (data.error) {
            make_modal({
                'title': 'エラー',
                'body': data.messageText,
            });
            return false;
        }
    },
    // 削除成功時のコールバック
    destroy_callback(data) {
        const target = document.querySelector('#id_' + data.data.id);
        new bootstrap.Collapse(target, {
            hide: true
        });
        // トーストを表示
        make_toast(data.toasts);
    },


    /*#########################################################
        サムネイル一覧取得
    #########################################################*/
    thumbnail(order_id = null) {
        let formdata = new FormData();
        formdata.append('order_id', order_id);
        if (target_cover && target_body) {
            target_cover.innerHTML = spinner_border;
            target_body.innerHTML = spinner_border;
        }
        const data = api({
            api: '/api/user/upload',
            _method: "GET",
            formdata: formdata,
            callback: this.get_s3_url,
            e_callback: null,
        });
    },
    // データの内容チェック
    check_data(data) {
        const item = data.data.item_json;
        const uploads = data.data.uploads;
        // 表紙ページ数：色数に0が含まれている場合は1P、それ以外は最大2P（表紙は見開きデータ入稿のため）と判断
        const cover_page = (item.cover_color.value == "4-0" || item.cover_color.value == "1-0") ? 1 : 2;
        // 本文ページ数
        const body_page = item.page_num.value;
        // アップロードデータのカウント
        let upload_cover_page = 0;
        let upload_body_page = 0;
        const $alert_box = document.querySelector('#alert_box');
        const $alart_body = $alert_box.querySelector('.alart_body');
        let has_error = false;
        uploads.forEach(upload => {
            // アップロードデータのページ数をカウント
            if (upload.part == "body") {
                upload_body_page += upload.thumbnail_meta.pagecount;
            } else if (upload.part == "cover") {
                upload_cover_page += upload.thumbnail_meta.pagecount;
            }
            // サムネイル生成時のエラーを表示
            if (upload.thumbnail_error) {
                $alart_body.insertAdjacentHTML("beforeend", `<li>アップロードされた<strong>${upload.original_name}</strong>は、${upload.thumbnail_error}<small>このまま入稿をすることも可能ですがこちらでリサイズされることをご了承ください。尚、あきらかに不向きなデータの場合はこちらから再入稿の連絡をさせていただきます。</small></li>`);
                has_error = true;
            }
        });
        if (upload_cover_page > cover_page) {
            $alart_body.insertAdjacentHTML("beforeend", `<li>表紙のデータが<strong>多い</strong>ので、データ入稿に戻ってデータを<strong>削除</strong>してください。</li>`);
            if(cover_page == 1){
                $alart_body.insertAdjacentHTML("beforeend", `<li>表紙の印刷色数は「カラー／なし」もしくは「モノクロ／なし」が選択されているため、<strong>表紙裏ページデータは必要ありません</strong>。</li>`);
            }
            has_error = true;
        } else if (upload_cover_page < cover_page) {
            $alart_body.insertAdjacentHTML("beforeend", `<li>表紙のデータが<strong>少ない</strong>ので、データ入稿に戻ってデータを<strong>追加</strong>してください。</li>`);
            has_error = true;
        }
        if (upload_body_page > body_page) {
            $alart_body.insertAdjacentHTML("beforeend", `<li>本文のデータが<strong>${upload_body_page - body_page}ページ多い</strong>ので、データ入稿に戻ってデータを<strong>削除</strong>してください。</li>`);
            has_error = true;
        } else if (upload_body_page < body_page) {
            $alart_body.insertAdjacentHTML("beforeend", `<li>本文のデータが<strong>${body_page - upload_body_page}ページ少ない</strong>ので、データ入稿に戻ってデータを<strong>追加</strong>してください。</li>`);
            has_error = true;
        }
        if (has_error) {
            $alert_box.style.display = "block";
        }
    },
    // S3URLの取得
    get_s3_url(data) {
        upload.check_data(data);
        const d = data.data.uploads;
        // サムネイルURL一覧の取得
        let file_urls = [];
        for (const i in d) {
            if (!d[i].thumbnail_meta) { continue; }
            const Put_Prefix = d[i].thumbnail_meta.Put_Prefix;
            const Bucket = d[i].thumbnail_meta.Bucket;
            file_urls.push({
                Put_Prefix,
                Bucket,
                path: d[i].path,
                files: d[i].thumbnail_meta.files,
                data: {
                    id: d[i].id,
                    original_name: d[i].original_name,
                    part: d[i].part, // 表紙か本文か
                    file_info: d[i].thumbnail_meta.file_info || null, // ファイルのサイズ関連の情報
                    direction: data.data.item_json.binding.direction, // 綴じ方向
                }
            });
        }
        let formdata = new FormData();
        formdata.append('file_urls', JSON.stringify(file_urls));
        api({
            api: '/api/user/url/s3',
            _method: "GET",
            formdata: formdata,
            callback: upload.thumbnail_showing,
            e_callback: null,
        });
    },
    // 一覧データの表示
    thumbnail_showing(data) {
        target_cover.querySelector('.spinner').remove();
        target_body.querySelector('.spinner').remove();
        // ## 取得したデータをテンプレートに設定
        const d = data.data;
        // サムネイルURL一覧の取得
        let cover_thumbnails = [];
        let body_thumbnails = [];
        for (const i in d) {
            // 元ファイルのデータを取得
            const thumbnail_data = d[i];
            const thumbnails = thumbnail_data.thumbnails;
            for (const f in thumbnails) {
                const tmp = {
                    url: thumbnails[f].url,
                    error: thumbnails[f].error,
                    info: thumbnails[f].info,
                    data: thumbnail_data.data
                };
                if (d[i].data.part == "cover") {
                    cover_thumbnails.push(tmp);
                } else if (d[i].data.part == "body") {
                    body_thumbnails.push(tmp);
                }
            }
        }
        upload.thumbnail_rendering(cover_thumbnails, "cover");
        upload.thumbnail_rendering(body_thumbnails, "body");
        return;
    },
    // 一覧データのレンダリング
    thumbnail_rendering(thumbnails, part = "body") {
        if (part == "cover") {
            target = target_cover;
            template_thumbnail = template_cover_thumbnail
        } else {
            target = target_body;
            template_thumbnail = template_body_thumbnail
        }
        let row = document.createElement("div");
        for (const i in thumbnails) {
            // 最初のファイルかどうか
            let is_first_page = (i == 0) ? true : false;
            const thumbnail = template_thumbnail.cloneNode(true);
            const start = (part == "cover") ? ["text-center", "align-self-center"] : (thumbnails[i].data.direction == "left") ? ["text-start", "order-last", "ms-auto"] : ["text-end", "order-first", "me-auto"];
            const end = (part == "cover") ? ["text-center", "align-self-center"] : (thumbnails[i].data.direction == "left") ? ["text-end", "order-first", "me-auto"] : ["text-start", "order-last", "ms-auto"];
            if (i % 2 == 0) {
                thumbnail.classList.add(...start);
            } else {
                thumbnail.classList.add(...end);
            }
            thumbnail.querySelector('[data-content="thumbnail"]').src = thumbnails[i].url;
            if (part == "cover") {
                if (i == 0) {
                    thumbnail.querySelector('[data-content="page-num"]').insertAdjacentHTML("beforeend", `表1-表4ページ <small>（${thumbnails[i].data.original_name}）</small>`);
                } else {
                    thumbnail.querySelector('[data-content="page-num"]').insertAdjacentHTML("beforeend", `表2-表3ページ <small>（${thumbnails[i].data.original_name}）</small>`);
                }
            } else {
                thumbnail.querySelector('[data-content="page-num"]').insertAdjacentHTML("beforeend", `${parseInt(i) + 1}ページ <small>（${thumbnails[i].data.original_name}）</small>`);
            }
            let error_text = "";
            if (thumbnails[i].error) {
                for (const e in thumbnails[i].info.error) {
                    error_text += thumbnails[i].info.error[e] + "<br>";
                }
            }
            thumbnail.querySelector('[data-content="page-error"]').insertAdjacentHTML("beforeend", `${error_text}`);
            // 行に追加
            row.appendChild(thumbnail);
            if (i % 2 == 0 || is_first_page) {
                target.appendChild(row);
                row = document.createElement("div");
                row.className = 'row';
            }
            if (i % 2 != 0 && thumbnails.length - 1 == i) {
                target.appendChild(row);
            }
        }
        if (thumbnails.length == 0) {
            target.insertAdjacentHTML("beforeend", '<div class="alert alert-warning" role="alert">データがありません。</div>');
        }
    }

}


